<template>
  <div>
    <b-row class="mt-5">
      <b-col md="6" lg="4" v-for="item in references" :key="item.id">
        <router-link :to="`/references/${item.id}`" style="color: inherit; text-decoration: none;">
          <b-card no-body>
            <div class="image-container">
              <b-card-img
                :src="getGalleryReferenceImage(item, 'THUMBNAIL') ? getGalleryReferenceImage(item, 'THUMBNAIL') : require('@/assets/img/placeholder.jpg')"
              ></b-card-img>
            </div>
            <b-row class="mt-3">
              <b-col v-if="getGalleryReferenceImage(item, 'ICON')" cols="3">
                <b-img :src="getGalleryReferenceImage(item, 'ICON')" class="icon"></b-img>
              </b-col>
              <b-col :cols="getGalleryReferenceImage(item, 'ICON') ? 9 : 12">
                <b-card-text>
                  <strong>{{ item.title[currentLanguage] ? item.title[currentLanguage] : item.title["de"] }}</strong>
                  <br />
                  {{ getTranslatedSubTitle(item.subTitle) }}
                </b-card-text>
              </b-col>
            </b-row>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    <b-row v-if="(references || []).length < totalCount" class="my-5">
      <b-col class="d-flex justify-content-center">
        <b-button variant="primary" @click="fetchFurtherEntries()">{{ $t('showMore').toUpperCase() }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("references", ["references", "totalCount", "loading"]),
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations("references", ["setFetchParams"]),
    ...mapActions("references", ["fetchReferences"]),
    getGalleryReferenceImage(reference, use) {
      if (!reference) return null;
      const file = [...reference.attachedFiles]
        .sort(() => Math.random() - 0.5)
        .find(
          (file) => file.mimetype.startsWith("image/") && file.use.includes(use)
        );
      return (
        file && `${process.env.VUE_APP_API_BASE_URL}/files/${file.id}?img_w=960`
      );
    },
    getTranslatedSubTitle(subTitle) {
      if (!subTitle) return "";
      if (subTitle[this.currentLanguage]) return subTitle[this.currentLanguage];
      return "";
    },
    fetchFurtherEntries() {
      this.setFetchParams({ offset: this.references.length });
      this.fetchReferences({ append: true });
    },
  },
  created() {
    this.setFetchParams({ offset: 0, limit: 10 });
    this.fetchReferences();
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
  margin-bottom: 30px;

  .image-container {
    height: 200px;
    width: 100%;

    .card-img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
}

.icon {
  max-width: 50px;
  max-height: 50px;
}
</style>